// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-HeadProfiles-styles--root--Wuh7O {
  display: none;
  text-align: left;
}

@media screen and (min-width: 768px) {

.src-components-HeadProfiles-styles--root--Wuh7O {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: auto;
    margin-right: auto;
    max-width: 731px;
}
  }

@media screen and (min-width: 1024px) {

.src-components-HeadProfiles-styles--root--Wuh7O {
    max-width: 930px;
}
  }

@media screen and (min-width: 1280px) {

.src-components-HeadProfiles-styles--root--Wuh7O {
    max-width: 1245px;
}
  }

.src-components-HeadProfiles-styles--root--Wuh7O a,.src-components-HeadProfiles-styles--root--Wuh7O span {
    margin-left: 15px;
  }

.src-components-HeadProfiles-styles--logo--tjPLn {
  margin-right: -5px;
}

.src-components-HeadProfiles-styles--logo--tjPLn > *,
.src-components-HeadProfiles-styles--profiles--CsxM9 > * {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/HeadProfiles/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,aAAa;EACb,gBAAgB;AAuBlB;;AArBE;;AAJF;IAKI,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AAepB;EAdE;;AAEA;;AAbF;IAcI,gBAAgB;AAWpB;EAVE;;AAEA;;AAjBF;IAkBI,iBAAiB;AAOrB;EANE;;AAEA;IAEE,iBAAiB;EACnB;;AAGF;EACE,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  display: none;\n  text-align: left;\n\n  @media (--desktop) {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 731px;\n  }\n\n  @media (--desktop-l) {\n    max-width: 930px;\n  }\n\n  @media (--desktop-x) {\n    max-width: 1245px;\n  }\n\n  & a,\n  & span {\n    margin-left: 15px;\n  }\n}\n\n.logo {\n  margin-right: -5px;\n}\n\n.logo > *,\n.profiles > * {\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-HeadProfiles-styles--root--Wuh7O`,
	"logo": `src-components-HeadProfiles-styles--logo--tjPLn`,
	"profiles": `src-components-HeadProfiles-styles--profiles--CsxM9`
};
module.exports = ___CSS_LOADER_EXPORT___;
